import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { massDestroyRoles } from "../../api/apiRoles";
import parseError from "../../utils/parseError";

export const useMassDestroyRoles = () => {
    const queryClient = useQueryClient();
    const { mutate: massDestroyRolesMutate, isPending } = useMutation({
        mutationFn: massDestroyRoles,
        onSuccess: (res) => {
            toast.success(res.message || "Roles deleted successfully");
            queryClient.invalidateQueries(["roles"]);
        },
        onError: (e) => toast.error(parseError(e) || "Failed to delete roles"),
    });
    return { massDestroyRolesMutate, isPending };
};
